import I18n from '../../languages/I18n';

const SERVICES = [
  { key: 'service_1',  icon_on: 'access_on.png',     icon_off: 'access_off.png' },
  { key: 'service_2',  icon_on: 'parking_on.png',    icon_off: 'parking_off.png' },
  { key: 'service_3',  icon_on: 'water_on.png',      icon_off: 'water_off.png' },
  { key: 'service_4',  icon_on: 'jeux_on.png',       icon_off: 'jeux_off.png' },
  { key: 'service_5',  icon_on: 'sanitaires_on.png', icon_off: 'sanitaires_off.png' },
  { key: 'service_6',  icon_on: 'surv_on.png',       icon_off: 'surv_off.png' },
  { key: 'service_7',  icon_on: 'wifi_on.png',       icon_off: 'wifi_off.png' },
  { key: 'service_8',  icon_on: 'resto_on.png',      icon_off: 'resto_off.png' },
  { key: 'service_9',  icon_on: 'no_dog_on.png',     icon_off: 'no_dog_off.png' },
  { key: 'service_10', icon_on: 'shower_on.png',     icon_off: 'shower_off.png' },
];

/* require() must be static — preload all icons */
const SERVICE_ICONS = {
  'access_on.png':      require('../../assets/services/access_on.png'),
  'access_off.png':     require('../../assets/services/access_off.png'),
  'parking_on.png':     require('../../assets/services/parking_on.png'),
  'parking_off.png':    require('../../assets/services/parking_off.png'),
  'water_on.png':       require('../../assets/services/water_on.png'),
  'water_off.png':      require('../../assets/services/water_off.png'),
  'jeux_on.png':        require('../../assets/services/jeux_on.png'),
  'jeux_off.png':       require('../../assets/services/jeux_off.png'),
  'sanitaires_on.png':  require('../../assets/services/sanitaires_on.png'),
  'sanitaires_off.png': require('../../assets/services/sanitaires_off.png'),
  'surv_on.png':        require('../../assets/services/surv_on.png'),
  'surv_off.png':       require('../../assets/services/surv_off.png'),
  'wifi_on.png':        require('../../assets/services/wifi_on.png'),
  'wifi_off.png':       require('../../assets/services/wifi_off.png'),
  'resto_on.png':       require('../../assets/services/resto_on.png'),
  'resto_off.png':      require('../../assets/services/resto_off.png'),
  'no_dog_on.png':      require('../../assets/services/no_dog_on.png'),
  'no_dog_off.png':     require('../../assets/services/no_dog_off.png'),
  'shower_on.png':      require('../../assets/services/shower_on.png'),
  'shower_off.png':     require('../../assets/services/shower_off.png'),
};

const divider = <div style={{ height: 1, backgroundColor: '#EDF3F4', margin: '0 20px' }} />;

const BeachDetailsBody = props => {
  const row1 = SERVICES.slice(0, 5);
  const row2 = SERVICES.slice(5, 10);

  return (
    <div style={{ width: '100%', boxSizing: 'border-box', paddingBottom: 30 }}>

      {/* Description */}
      {props.description && (
        <>
          <div style={{ display: 'flex', flexDirection: 'row', padding: '16px 20px', alignItems: 'flex-start' }}>
            <span style={{ fontSize: 38, color: '#cacaca', lineHeight: 1, marginRight: 8, fontFamily: 'Georgia, serif' }}>"</span>
            <p style={{ fontSize: 15, color: '#333337', lineHeight: 1.6, margin: 0, paddingTop: 8 }}>
              {props.description}
            </p>
          </div>
          {divider}
        </>
      )}

      {/* Surveillance / opening hours */}
      {props.opening_desc && (
        <>
          <div style={{ padding: '16px 20px' }}>
            <div style={{ fontSize: 15, fontWeight: '700', textAlign: 'center', color: '#333337' }}>
              {I18n.t('beach_details.oversight')}
            </div>
            <div style={{ width: '20%', marginLeft: '40%', height: 1, backgroundColor: '#64CFE1', marginTop: 4 }} />
            <div style={{
              color: 'rgb(51,51,55)',
              fontSize: 15,
              textAlign: 'center',
              marginTop: 12,
              lineHeight: 1.6,
              whiteSpace: 'pre-wrap',
            }}>
              {props.opening_desc}
            </div>
          </div>
          {divider}
        </>
      )}

      {/* Démarche qualité eau de baignade */}
      {props.demarche_qualite === 1 && (
        <>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '14px 20px', gap: 12 }}>
            <span style={{ fontSize: 15, color: '#333337', fontWeight: '600', textAlign: 'center' }}>
              {'« ' + I18n.t('beach_details.demarche_qualite') + ' »'}
            </span>
            <img src={require('../../assets/eau_de_baignade.png')} alt="qualité eau" style={{ width: 43, height: 33, objectFit: 'contain', flexShrink: 0 }} />
          </div>
          {divider}
        </>
      )}

      {/* Pavillon Bleu */}
      {props.pavillon_bleu === 1 && (
        <>
          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', padding: '14px 20px', gap: 12 }}>
            <span style={{ fontSize: 15, color: '#333337', fontWeight: '600', textAlign: 'center' }}>
              {'« ' + I18n.t('beach_details.pavillon_bleu') + ' »'}
            </span>
            <img src={require('../../assets/pavillon_bleu.png')} alt="pavillon bleu" style={{ width: 43, height: 33, objectFit: 'contain', flexShrink: 0 }} />
          </div>
          {divider}
        </>
      )}

      {/* Services grid */}
      <div style={{ margin: '16px 20px 0', paddingBottom: 8 }}>
        {[row1, row2].map((row, ri) => (
          <div key={ri} style={{ display: 'flex', justifyContent: 'space-around', marginTop: 16 }}>
            {row.map(svc => {
              const active = props[svc.key];
              const icon = SERVICE_ICONS[active ? svc.icon_on : svc.icon_off];
              return (
                <div key={svc.key} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1 }}>
                  <img
                    alt={svc.key}
                    src={icon}
                    style={{ width: 36, height: 36, objectFit: 'contain', opacity: active ? 1 : 0.25 }}
                  />
                </div>
              );
            })}
          </div>
        ))}
      </div>

      {/* Bouton EN SAVOIR PLUS */}
      {/* {props.more_info && (
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: 24 }}>
          <a
            href={props.more_info}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              display: 'flex',
              alignItems: 'center',
              border: '1px solid #333337',
              borderRadius: 30,
              padding: '8px 20px',
              fontSize: 12,
              fontWeight: '700',
              color: '#333337',
              textDecoration: 'none',
            }}>
            {I18n.t('beach_details.more_info')}
          </a>
        </div>
      )} */}

    </div>
  );
};

export default BeachDetailsBody;
